module.exports = __webpack_public_path__ + "media/gpt.9c89d0e6.webm";